module.exports = __webpack_public_path__ + "img/github-squares.61b81768.png";